export default __webpack_public_path__ + "static/media/Eye_7_F_C4.c4076cd0.svg";